import { render, staticRenderFns } from "./AppComp.vue?vue&type=template&id=05ccb80c"
import script from "./AppComp.vue?vue&type=script&lang=js"
export * from "./AppComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports